/* global axios */
import { msBaseUrl } from './microservicos';

export const dailyRecordsAPI = {
  search(accountId, params = {}) {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== '' && v !== null)
    );
    return axios.get(`${msBaseUrl('crm', accountId)}/daily-records`, {
      params: cleanParams,
    });
  },

  exportPdf(accountId, params = {}) {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== '' && v !== null)
    );
    return axios.get(`${msBaseUrl('crm', accountId)}/daily-records/export`, {
      params: cleanParams,
      responseType: 'blob',
    });
  },

  // Fechamento Financeiro: mesmo recorte do exportPdf, mas agrupado por profissional e
  // valorizado pela tabela de preços. Sem authorAgentId — é relatório de administrador.
  exportFinancialClosing(accountId, params = {}) {
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== '' && v !== null)
    );
    return axios.get(
      `${msBaseUrl('crm', accountId)}/daily-records/financial-closing`,
      {
        params: cleanParams,
        responseType: 'blob',
      }
    );
  },

  create(accountId, data) {
    return axios.post(`${msBaseUrl('crm', accountId)}/daily-records`, data);
  },

  update(accountId, id, data) {
    return axios.put(
      `${msBaseUrl('crm', accountId)}/daily-records/${id}`,
      data
    );
  },

  delete(accountId, id) {
    return axios.delete(`${msBaseUrl('crm', accountId)}/daily-records/${id}`);
  },

  // activeOnly: estas duas alimentam os selects de Registros Diários. Ficha inativa não
  // pode ser oferecida — lançar um atendimento nela é registrar trabalho num cadastro
  // que foi desativado ou consolidado noutro.
  professionals(accountId) {
    return axios.get(`${msBaseUrl('crm', accountId)}/persons`, {
      params: { classification: 'Profissional', activeOnly: true },
    });
  },

  patients(accountId) {
    return axios.get(`${msBaseUrl('crm', accountId)}/persons`, {
      params: { classification: 'Paciente', activeOnly: true },
    });
  },
};
